import { Layout, Notification } from "react-admin";
import Menu from "./Menu";
import CustomAppBar from "./CustomAppBar";

const MyLayout = (props: any) => {
  return (
    <Layout
      {...props}
      menu={Menu}
      appBar={CustomAppBar}
      notification={Notification}
    />
  );
};

export default MyLayout;
